var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShowHideDocumentViewIcon = function SvgShowHideDocumentViewIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 18.5v5.25c0 .42.33.75.75.75h4.5c.42 0 .75-.33.75-.75V18.5c0-.42-.33-.75-.75-.75h-4.5c-.42 0-.75.33-.75.75zM12 23.75V18.5c0-.42.33-.75.75-.75h4.5c.42 0 .75.33.75.75v5.25c0 .42-.33.75-.75.75h-4.5c-.42 0-.75-.33-.75-.75zm-2.25-6h-4.5c-.42 0-.75.33-.75.75v5.25c0 .42.33.75.75.75h4.5c.42 0 .75-.33.75-.75V18.5c0-.42-.33-.75-.75-.75zm5.246-12.321 5.785 9.642H9.21l5.786-9.642z"
  })));
};

export default SvgShowHideDocumentViewIcon;